import { h } from 'preact';
import { darkText, headBg, lightText } from '../../../facebook-video/creative/config';
import { useAdParameters } from '../hooks/useAdParameters';
import { useOptimizedAsset } from '../hooks/useOptimizedAsset';
import { useTextKeywords } from '../hooks/useTextKeywords';
import { getLocaleForLanguage } from '../locales';
import { fb_tag } from '../theme';
import { highlightTags } from './lib';
import { LineClamp } from './line-clamp';

export interface FacebookHeaderProps {
  lines: number;
}

const head = {
  paddingBlockStart: 10,
  paddingBlockEnd: 0,
  paddingInlineStart: 10,
  paddingInlineEnd: 10,
  flex: '0 0 auto',
  background: headBg,
};
const topStyle = {
  display: 'flex',
  alignItems: 'flex-end',
  marginBottom: '12px',
};
const logoStyle = {
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
  overflow: 'hidden',
  objectFit: 'contain',
  border: '1px solid #F1F1F1',
};
const brand = {
  marginInlineStart: 8,
};
const txt = {
  fontSize: '14px',
  fontWeight: 'bold',
  lineHeight: '17px',
  color: darkText,
  maxHeight: '17px',
  overflow: 'hidden',
};
const spo = {
  fontSize: '12px',
  lineHeight: '16px',
  color: lightText,
};

export function FacebookHeader({ lines }: FacebookHeaderProps) {
  const { config = {} } = useAdParameters<any>();
  const locale = getLocaleForLanguage(config.ctaLanguage);
  const { brand_name, logo, text } = config;
  const primaryText = useTextKeywords(text, locale);
  const logoUri = useOptimizedAsset(logo);
  const lineHeight = 18;
  const pri = {
    lineHeight: lineHeight + 'px',
    color: darkText,
    fontSize: '14px',
    maxHeight: lines * lineHeight + 'px',
    marginBlockEnd: 8,
  };
  return (
    <div style={head}>
      <div style={topStyle}>
        <img style={logoStyle} src={logoUri || logo.placeholder || ''} />
        <div style={brand}>
          <div style={txt}>{brand_name}</div>
          <div style={spo}>Sponsored</div>
        </div>
      </div>
      {text && (
        <LineClamp
          lines={3}
          lineHeight={lineHeight}
          text={primaryText}
          dots={true}
          styleWord={highlightTags(fb_tag)}
          style={pri}
          keywords
        />
      )}
    </div>
  );
}
